import axios from "axios";
import router from "@/router";

const getDefaultState = () => {
  return {
    allDevices: [],
    allDevicesLoading: false,
    fields: {
      ALL_DEVICES: `
        id
        status
        product
        imei
        batch
        brand
        order {
          id
          order_no
        }
        customer {
          id
          company_name
        }
        updated_at
        created_at
        _rowVariant
      `
    }
  };
};

const state = getDefaultState();

const getters = {
  getAllDevices(state) {
    return state.allDevices;
  },
  getAllDevicesLoading(state) {
    return state.allDevicesLoading;
  },
};

const actions = {
  fetchDevicesPagination({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            devices: DevicesPagination (
              ${ payload.status != null ? `status: "${payload.status}",` : ''}
              ${ payload.product != null ? `product: "${payload.product}",` : ''}
              limit: ${payload.limit},
              offset: ${payload.offset},
              order: "${payload.order}"
            ) { ${state.fields.ALL_DEVICES} }
          }
        `
      }
    };

    dispatch("fetchCommitDevices", commitPayload);
  },
  fetchDevicesLikeImei({ state, dispatch }, payload) {
    const commitPayload = {
      this_ref: payload.this_ref,
      data: {
        query: `
          query {
            devices: DevicesLikeImei(
              imei: "${payload.imei}",
              limit: ${payload.limit},
              offset: ${payload.offset},
            ) {
              ${state.fields.ALL_DEVICES}
            }
          }
        `
      }
    };

    dispatch("fetchCommitDevices", commitPayload);
  },
  fetchCommitDevices({ commit, rootGetters, dispatch }, payload) {
    return new Promise((resolve) => {
      commit("setAllDevicesLoading", true);

      axios
        .post(rootGetters.getGraphQlUrl, payload.data, rootGetters.getDefConf)
        .then(res => {
          if (res.data.errors !== undefined && res.data.errors.length > 0) {
            res.data.errors.forEach(e => {
              // Check for timeout error to logout
              if (e.message == "Login timeout, logout and login again.") {
                dispatch("auth/logOut", null, { root: true });
                resolve(false);
              }

              dispatch("axios_mod/makeErrorToast", {
                this_ref: payload.this_ref,
                content: e.message != null ? e.message : "Something went wrong."
              }, { root: true });
            });
            resolve(false);
          } else {
            commit('setAllDevices', res.data.data.devices);
            resolve();
          }
        })
        .catch(err => {
          dispatch("axios_mod/makeErrorToast", {
            this_ref: payload.this_ref,
            content: err != null ? err : "Something went wrong."
          }, { root: true });
          resolve(false);
        })
        .finally(()=>{ commit("setAllDevicesLoading", false) });
    });
  },
};

const mutations = {
  setAllDevices(state, value) {
    state.allDevices = value;
  },
  setAllDevicesLoading(state, value) {
    state.allDevicesLoading = value;
  },
  resetState(state) {
    Object.assign(state, getDefaultState());
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
